import React, { useState } from 'react';
import { useMotionValue, AnimatePresence } from 'framer-motion';
import Background from './components/Background';
import Particles from './components/Particles';
import Pouch3D from './components/Pouch3D';
import Content from './components/Content';
import OrderModal from './components/OrderModal';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const { innerWidth, innerHeight } = window;
    const x = (clientX / innerWidth) * 2 - 1;
    const y = (clientY / innerHeight) * 2 - 1;
    mouseX.set(x);
    mouseY.set(y);
  };

  return (
    <main 
      className="relative w-full h-screen overflow-hidden bg-brand-green font-sans selection:bg-brand-gold selection:text-brand-green flex flex-col items-center justify-center"
      onMouseMove={handleMouseMove}
      onTouchMove={(e) => {
        const touch = e.touches[0];
        if(touch) {
          handleMouseMove({ clientX: touch.clientX, clientY: touch.clientY });
        }
      }}
    >
      <Background />
      <Particles />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <Pouch3D mouseX={mouseX} mouseY={mouseY} />
        <Content mouseX={mouseX} mouseY={mouseY} onOpenModal={() => setIsModalOpen(true)} />
      </div>

      <AnimatePresence>
        {isModalOpen && (
          <OrderModal onClose={() => setIsModalOpen(false)} />
        )}
      </AnimatePresence>
    </main>
  );
}

export default App;